import React from 'react';
import DatePicker from './DatePicker';

interface DateRangePickerProps {
  label?: string;
  startDate?: Date | null;
  endDate?: Date | null;
  onChange?: (dates: [Date | null, Date | null]) => void;
  placeholder?: string;
  className?: string;
  usePortal?: boolean;
}

const DateRangePicker: React.FC<DateRangePickerProps> = ({
  label = 'Date Range',
  startDate,
  endDate,
  onChange,
  placeholder = 'Select date range',
  className = '',
  usePortal = true,
}) => {
  const handleRangeChange = (dates: [Date | null, Date | null]) => {
    if (onChange) {
      onChange(dates);
    }
  };

  return (
    <DatePicker
      label={label}
      placeholder={placeholder}
      selectsRange={true}
      startDate={startDate}
      endDate={endDate}
      onRangeChange={handleRangeChange}
      className={className}
      usePortal={usePortal}
    />
  );
};

export default DateRangePicker;